<template>
  <div>
    <!-- todo - https://stackoverflow.com/questions/50392918/vuetify-how-to-preselect-active-tab
     -->
    <v-tabs v-model="activetab" align-with-title>
      <v-tab
        v-for="tab of tabs"
        :key="tab.id"
        :id="`sharedListSequenceTab${tab.id}`"
        :class="`shared-list-sequence-tab-${tab.id}`"
        @click="WarnUser(tab.to)"
      >
        <span>{{ tab.caption }}</span>
      </v-tab>
    </v-tabs>
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'SharedProgram',
  components: {},
  created() {
    this.getPathName(this.$route.path);
  },
  data: () => ({
    dialog: false,
    path: '',
    activetab: 0,
    tabs: [
      { id: 1, to: { path: '/shared/banks' }, caption: 'Banks' },
      { id: 2, to: { path: '/shared/funds' }, caption: 'Funds' },
      { id: 3, to: { path: '/shared/source' }, caption: 'Sources' },
      { id: 4, to: { path: '/shared/taxmortgagecodes' }, caption: 'Mortgage Codes' },
      { id: 5, to: { path: '/shared/taxstatuscodes' }, caption: 'Status Codes' },
      { id: 6, to: { path: '/shared/taxfeetypes' }, caption: 'Fees' },
      { id: 7, to: { path: '/shared/taxadjtypes' }, caption: 'ADJ Types' },
      { id: 8, to: { path: '/shared/taxCommentTypes' }, caption: 'Comment Types' },
      { id: 9, to: { path: '/shared/taxReasonCode' }, caption: 'Reason Codes' },
      { id: 10, to: { path: '/shared/taxadditions' }, caption: 'Additions' },
      { id: 11, to: { path: '/shared/taxstreets' }, caption: 'Streets' },
      { id: 12, to: { path: '/shared/taxLevy' }, caption: 'Tax Levy' },
      { id: 13, to: { path: '/shared/taxUnit' }, caption: 'Tax Unit' },
      { id: 14, to: { path: '/shared/remitUnit' }, caption: 'Remit Units' },
      { id: 15, to: { path: '/shared/taxDistrict' }, caption: 'Tax Districts' },
      { id: 16, to: { path: '/shared/taxFund' }, caption: 'Tax Fund' },
      { id: 17, to: { path: '/shared/taxrollsummary' }, caption: 'Tax Roll Summary' },
      { id: 18, to: { path: '/shared/dropdowns' }, caption: 'Drop Downs' },
    ],
  }),
  methods: {
    getPathName(curPath) {
      const ftr = this.tabs.filter((ft) => ft.to.path === curPath);
      this.activetab = ftr[0].id !== undefined ? ftr[0].id - 1 : 0;
    },
    WarnUser(path) {
      this.path = path;
      const currentpath = this.$router.currentRoute.path;
      if (path.path !== currentpath) {
        this.$router.push(path);
      }
    },
  },
  computed: {},
};
</script>

<style></style>
